module.exports = __webpack_public_path__ + "static/media/23.a80b1e96.png";